import { nsModel } from "../../../lib/namespace";

export const utilityNS = nsModel("utility");
